import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import DraftingServices from './components/DraftingServices';
import ProcessSection from './components/ProcessSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import ToolsSection from '../../components/feature/ToolsSection';

export default function ServicesPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <DraftingServices />
        <ToolsSection />
        <ProcessSection serviceType="drafting" />
        <ComparisonSection />
        <CTASection serviceType="drafting" />
      </main>
      <Footer />
    </div>
  );
}